import { render, staticRenderFns } from "./TikklokDebug.vue?vue&type=template&id=5e507c7e&scoped=true"
import script from "./TikklokDebug.vue?vue&type=script&lang=js"
export * from "./TikklokDebug.vue?vue&type=script&lang=js"
import style0 from "./TikklokDebug.vue?vue&type=style&index=0&id=5e507c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e507c7e",
  null
  
)

export default component.exports